export default __webpack_public_path__ + "static/media/Medium-icon.724c103e.svg";